import * as React from 'react';

import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';
import { HomePage, HomePageTab } from './model';
import { tzmoment } from 'lib/tzmoment';

import { MapView } from './mapview';
import { CruiseScheduleView } from './cruisescheduleview';
import { InPortView } from './inportview';
import { MovementsView } from './movementsview';
import { LoginView } from 'portcall/login/view';
import { TypeaheadInput } from 'portcall/typeahead/view';
import { PCModal } from 'portcall/pcmodal/view';

export let HomePageView = SuperCritical(({ model } : { model : HomePage }) => {
    var settings = model.Domain.Settings()!.Homepage.Banner;
    var domainUOM = model.Domain.Settings()!.Pier.DefaultLengthUOM() ?? 'ft';
    return (
        <div className="homepage-shell">
            <div className="homepage-header-backgrounds">
                {/* TH: Need to wrap BannerUrl in CSS url() syntax to be able to use as the background-image property.
                    NOTE: I'm assuming our BannerUrl won't contain characters like double or single quotes that need escaping inside our CSS.
                    Since we control the BannerUrl, that seems safe, but if we REALLY need double or single quotes inside that filename for some reason, then we could do some escaping here...*/}
                <div className="homepage-header-backgrounds-pic" style={{ backgroundImage : settings.Url() && 'url(' + settings.Url() + ')' }}></div>
                <div className="homepage-header-backgrounds-green"></div>
            </div>
                
            <div className = {'homepage pc-page-fixedwidth tab-' + HomePageTab[model.Tab()].toLowerCase() + (model.User() ? ' logged-in' : '')}>
                <div className="homepage-header">
                    <div className="intro" style={{ color: settings.TextColor() }}>
                        <label className="title"       style={{ textShadow: settings.TextShadowColor() && '2px 2px 4px ' + settings.TextShadowColor() }}>{model.Domain.HomePageTitle()}</label>
                        <label className="description" style={{ textShadow: settings.TextShadowColor() && '1px 1px 2px ' + settings.TextShadowColor() }}>{model.Domain.HomePageSubtitle()}</label>
                    </div>
                    <div className="login">
                        {!model.User() && model.InitialDataLoaded() && <button className="pc-button login-button" onClick = {() => model.ShowLogin(true)}>LOGIN</button>}
                    </div>
                    <div className="map-image">
                        <img onClick = {model.Tab.bind(null, HomePageTab.Map)} src={model.Map.Settings.ImageUrl() || undefined} />
                    </div>
                </div>
                
                <div className="home-menu"> 
                    {model.TabVisible(HomePageTab.Movements) ?
                        <div className={"menu-item" + (model.Tab() === HomePageTab.Movements ? ' selected' : '')} onClick = {model.Tab.bind(null, HomePageTab.Movements)} >
                            <label className="menu-item-title">TRAFFIC SCHEDULE</label>
                            <label className="menu-item-description">Daily arrivals, departures, and shifts</label>
                        </div> : null}
                    {model.TabVisible(HomePageTab.InPort) ?
                        <div className={"menu-item" + (model.Tab() === HomePageTab.InPort ? ' selected' : '')} onClick = {model.Tab.bind(null, HomePageTab.InPort)} >
                            <label className="menu-item-title">VESSELS IN PORT</label>
                            <label className="menu-item-description">List of current vessels</label>
                        </div> : null}
                    {model.TabVisible(HomePageTab.Cruise) ?
                        <div className={"menu-item" + (model.Tab() === HomePageTab.Cruise ? ' selected' : '')} onClick = {model.Tab.bind(null, HomePageTab.Cruise)} >
                            <label className="menu-item-title">CRUISE SCHEDULE</label>
                            <label className="menu-item-description">Yearly cruise ship schedules</label>
                        </div> : null}
                    {model.TabVisible(HomePageTab.Map) ?
                        <div className={"menu-item" + (model.Tab() === HomePageTab.Map ? ' selected' : '')} onClick = {model.Tab.bind(null, HomePageTab.Map)} >
                            <label className="menu-item-title">VIEW MAP</label>
                            <label className="menu-item-description">View berth locations</label>
                        </div> : null}
                </div>
                
                {model.Tab() === HomePageTab.Map ? null :
                    <div className="selectors">
                        {model.NumberOfPorts() > 1 ? 
                            <div className="port-picker">
                                <TypeaheadInput model = {model.PortTypeahead} className="filter-ctrl port-filter" placeholder="View by island or port" />
                                <a href="" className="show-all" onClick = {noDefault(() => model.PortFilter(''))}>Show All</a>
                            </div> : null
                        }
                        {model.Tab() === HomePageTab.Movements ?
                            <div className="pc-date-arrowpicker">
                                <div className="pc-button date-arrow" onClick = {model.DatePrev} >
                                    <span className="glyphicon glyphicon-chevron-left"></span>
                                </div>
                                <div className="pc-button date-text" onClick = {model.DateToday} >
                                    Today
                                </div>
                                <div className="pc-button date-arrow" onClick = {model.DateNext} >
                                    <span className="glyphicon glyphicon-chevron-left mirror-glyphicon IE-mirror-glyphicon"></span>
                                </div>
                            </div> : null
                        }
                        
                        {model.Tab() === HomePageTab.Movements ?
                            <div className="current-date">
                                <label>for {tzmoment(model.Date()).format('MMM D, YYYY')}</label>
                            </div> : null
                        }
                        
                        {model.Tab() === HomePageTab.InPort ?
                            <div className="current-date">
                                <label>for {tzmoment(model.Now).format('MMM D, YYYY')}</label>
                            </div> : null
                        }

                        {model.Tab() === HomePageTab.Cruise ?
                            <div className="current-date">
                                <label>for a rolling 18 months</label>
                            </div> : null
                        }
                    </div>
                }
                
                <MovementsView model = {model.Movements} />

                <InPortView model = {model.InPortVessels} goToPortCall = {model.GoToPortCall} />
            
                <CruiseScheduleView model= {model.CruiseSchedule} goToPortCall = { model.GoToPortCall } domainUOM = {domainUOM} />

                <MapView model = {model.Map} />
                
                <LoginView modelContainer={model.Login} />
            </div>
            {!model.IsCompliant() ?
                <PCModal className="cookie-compliance" shown={() => !model.IsCompliant()} onBackDropClick={() => {}}>
                    <div className="modal-content">
                        <div className="modal-body clearfix">
                            <h2 className="modal-title">Cookie Compliance</h2>
                            <div>
                                <div className="cookie-explanation">
                                    When logging into PortCall, we only place one necessary cookie on your machine to make our site work properly. It merely helps us ensure you only see information you have permission to see. We never track your actions on the site, and we never sell your personal information to anyone.
                                </div>
                                <div className="action-btns">
                                    <button className="pc-button" onClick={() => model.ShowCompliancy('compliant')}>I understand.</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </PCModal>
                : null
            }
        </div>
    );
})


// WEBPACK FOOTER //
// ./apps/portcall/homepage/view.tsx